import React, { Component } from 'react'
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import BoxButton from './../../../shared/components/BoxButton';
import MapSection from "./../../components/home/MapSection";
import SideDrawer from "./SideDrawer";
import {
    withWidth,
} from '@material-ui/core';
import { TextField, makeValidate, makeRequired, showErrorOnBlur } from 'mui-rff';
import DynamicElement from 'shared/components/DynamicElement'
import { Form } from 'react-final-form'
import * as yup from 'yup';
import api from 'shared/functions/api/';

const schema = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().required().email(),
    phone: yup.string().required(),
    companyName: yup.string().required(),
    message: yup.string().required(),
});
const validate = makeValidate(schema);
const required = makeRequired(schema);

const Heading = styled.h1`
  font-family: MinionPro-Disp;
    font-size: 100px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0;
    letter-spacing: normal;
    text-align: center;
    color: #313438;
    margin-top: 45px;

    @media (max-width: 600px){
        font-size: 55px;
        line-height: 1.4;
        margin-top: 0;
        margin-bottom: 0;
    }
`;

const TelephoneAndEmail = styled(props => <div {...props}>
    <div className="telephone-and-email-inner">
        <h1>
            <DynamicElement id="5ff8ebcd586fa2f4d4147a8a">
                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
        </h1>
    </div>
</div>)`
text-align: center;
margin-top: 100px;
margin-bottom: 40px;

.telephone-and-email-inner{
    display: inline-block;
    margin: 0 auto;
    position: relative;
   
    h1{
        height: 115px;
        font-family: MinionPro-Disp;
        font-size: 100px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        margin-top: 0px;
        margin-bottom: 0px;

        text-decoration: underline 3px #b08f6e;
        text-underline-offset: 8px;
    }
}

@media (max-width: 600px){
    margin-top: 30px;

    .telephone-and-email-inner h1{
        font-size: 55px;
        line-height: 1.18;
        text-decoration: underline 1px #b08f6e;
        text-underline-offset: 3px;
        max-width: 250px;
    }
}
`;

const ContactBox = styled(props => <div {...props}>
    <h3>{props.label}</h3>
    <p>{props.children}</p>
</div>)`
h3{
    height: 18px;
    font-family: MinionPro-Disp;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: ${props => props.align || 'center'};
    color: #b08f6e;
}
p{
  width: 234px;
  height: 97px;
  font-family: Lato;
  font-size: 16px;
  text-align: ${props => props.align || 'center'};
  color: #b6b8bc;
}

@media (max-width: 600px){
    h3{
       text-transform: uppercase;
       margin: 0;
    }
    p{
        height: auto;
    }
}
`;

const SectionHeader = styled.h1`
  font-family: MinionPro-Disp;
  font-size: 100px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin-bottom: 30px;
  margin-top: 160px;
  max-width: 620px;

  @media (max-width: 600px){
    font-size: 52px;
    line-height: 1.18;
    margin-top: 0;
    max-width: none;
    text-align: center;
  }
`;

const DoubleDiamond = styled(({ className }) => <svg className={className} xmlns="http://www.w3.org/2000/svg" width="243.113" height="349.239" viewBox="0 0 243.113 349.239">
    <g id="icon_branding_decor_3" transform="translate(-952.03 -918.904)">
        <path id="Path_3313" d="M528.958 146.634l-31.215 158.218-29.456 16.368 29.467 16.38 31.076 158.08 31.2-158.161 29.338-16.3-29.3-16.275z" className="cls-1" transform="translate(484.771 772.367)" />
        <path id="Path_3314" d="M528.958 146.634l-31.215 158.218-29.456 16.368 29.467 16.38 31.076 158.08 31.2-158.161 29.338-16.3-29.3-16.275z" className="cls-1" transform="translate(604.741 772.367)" />
    </g>
</svg>
)`
position: absolute;
position: absolute;
bottom: 100px;
right: 24px;
width: 116px;
height: 170px;
.cls-1{
    fill: none;
    stroke: #b08f6e;
}

@media (max-width: 600px){
    bottom: 165px;
    right: -54px;
    width: 72px;
    height: 98px;
}
`;

class ContactUs extends Component {

    state = {
        sideDrawerOpen: false
    }

    componentDidMount() {
        const { selectContactUs = () => { } } = this.props;
        selectContactUs();
    }

    closeDrawer = () => {
        this.setState({ sideDrawerOpen: false });
    };

    openDrawer = () => {
        this.setState({ sideDrawerOpen: true });
    };

    async onSubmit(data) {
        const { pushMessageToSnackbar } = this.props;
        try {
            const res = await api.post('/message', {...data, pageTitle: document.title});

            pushMessageToSnackbar({
                text: "Thanks for sending us your message!"
            });

            this.closeDrawer();
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        const { sideDrawerOpen } = this.state;
        const { width } = this.props;
        const isMobile = width === 'xs';
        return (
            <div style={{ backgroundColor: "#121416", position: 'relative' }}>
                <div className="lg-p-top">
                    <Heading>
                        <DynamicElement id="5ff8ec2e586fa2f4d4147a8b">
                            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                        </DynamicElement>
                    </Heading>

                    <TelephoneAndEmail />

                    <Box mb={!isMobile ? 13 : 4}>
                        <Grid container justify="center" spacing={4}>
                            <Grid item>
                                <ContactBox label={
                                    <DynamicElement id="5ff8eccc586fa2f4d4147a8d">
                                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                    </DynamicElement>
                                }>
                                    <DynamicElement id="5ff8ec72586fa2f4d4147a8c">
                                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                    </DynamicElement>
                                </ContactBox>
                            </Grid>
                            <Grid item>
                                <ContactBox label={
                                    <DynamicElement id="5ff8ecf8586fa2f4d4147a8e">
                                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                    </DynamicElement>
                                }>
                                    <DynamicElement id="5ff8ed2b586fa2f4d4147a8f">
                                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                    </DynamicElement>
                                </ContactBox>
                            </Grid>
                            <Grid item>
                                <ContactBox label={
                                    <DynamicElement id="5ff8ed41586fa2f4d4147a90">
                                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                    </DynamicElement>
                                }>
                                    <DynamicElement id="5ff8ed8d586fa2f4d4147a91">
                                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                    </DynamicElement>
                                </ContactBox>
                            </Grid>
                        </Grid>
                    </Box>

                    {!isMobile && <Box align="right">
                        <BoxButton
                            text="SEND A MESSAGE"
                            iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
                            onClick={this.openDrawer}
                        />
                    </Box>}
                </div>

                <Box
                    padding={!isMobile ? 10 : 7}
                    paddingTop={!isMobile ? 10 : 0}
                    paddingBottom={!isMobile ? 10 : 0}
                >
                    <Grid container spacing={!isMobile ? 10 : 4} direction={isMobile ? 'column' : 'row'}>
                        <Grid item xs>
                            <Box position="relative" align="center" paddingBottom={12} marginBottom={!isMobile ? 7 : 0}>

                                <DynamicElement id="5ff8f082586fa2f4d4147a97"
                                    style={{
                                        position: 'absolute',
                                        top: !isMobile ? 35 : 180,
                                        left: !isMobile ? 0 : -64,
                                        zIndex: 1,
                                    }}
                                >
                                    {({ value }) =>
                                        <img alt="" src={value} style={{
                                            width: !isMobile ? 210 : 127,
                                            height: !isMobile ? 153 : 93,
                                            objectFit: 'cover',
                                        }} />
                                    }
                                </DynamicElement>

                                <DynamicElement id="5ff8f0b7586fa2f4d4147a98" style={{
                                    margin: '0 auto',
                                    width: !isMobile ? 358 : '100%',
                                    height: !isMobile ? 482 : 'auto',
                                }}>
                                    {({ value }) =>
                                        <img alt="" src={value} style={{
                                            width: !isMobile ? 358 : '100%',
                                            height: !isMobile ? 482 : 'auto',
                                            objectFit: 'cover',
                                        }} />
                                    }
                                </DynamicElement>

                                <DynamicElement id="5ff8f0d9586fa2f4d4147a99"
                                    style={{
                                        zIndex: 1,
                                        position: 'absolute',
                                        right: !isMobile ? 80 : -20,
                                        bottom: !isMobile ? 0 : 40,
                                    }}>
                                    {({ value }) =>
                                        <img alt="" src={value} style={{
                                            width: !isMobile ? 210 : 128,
                                            height: !isMobile ? 153 : 93,
                                            objectFit: 'cover',

                                        }} />
                                    }
                                </DynamicElement>


                                <DoubleDiamond />
                            </Box>
                        </Grid>
                        <Grid item xs>

                            <SectionHeader>
                                <DynamicElement id="5ff8ee9b586fa2f4d4147a92">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </SectionHeader>

                            <Grid container spacing={4} style={isMobile ? {display: 'block'} : null}>
                                <Grid item>
                                    <ContactBox
                                        label={
                                            <DynamicElement id="5ff8eee1586fa2f4d4147a94">
                                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                            </DynamicElement>
                                        }
                                        align={isMobile ? 'center' : 'left'}
                                    >
                                        <DynamicElement id="5ff8eeb3586fa2f4d4147a93">
                                            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                        </DynamicElement>
                                    </ContactBox>
                                </Grid>
                                <Grid item>
                                    <ContactBox
                                        label={
                                            <DynamicElement id="5ff8ef13586fa2f4d4147a95">
                                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                            </DynamicElement>
                                        }
                                        align={isMobile ? 'center' : 'left'}
                                    >
                                        <DynamicElement id="5ff8ef2e586fa2f4d4147a96">
                                            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                        </DynamicElement>
                                    </ContactBox>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Box>

                {isMobile && <Box mt={7}>
                    <BoxButton
                        text="SEND A MESSAGE"
                        iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
                        onClick={this.openDrawer}
                    />
                </Box>}

                <MapSection />

                <SideDrawer
                    title={<div style={{ width: 180 }}>It's a pleasure to meet you</div>}
                    open={sideDrawerOpen}
                    onClose={this.closeDrawer}
                >
                    <Form
                        validate={validate}
                        onSubmit={data => this.onSubmit(data)}
                        render={({
                            handleSubmit,
                            pristine,
                            form,
                            submitting,
                            values,
                        }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <Box mt={3}>
                                        <TextField label="Name" fullWidth margin="dense" name="name" required={required.name} />
                                    </Box>
                                    <Box mt={3}>
                                        <TextField label="Email" fullWidth name="email" required={required.email} />
                                    </Box>
                                    <Box mt={3}>
                                        <TextField label="Phone" fullWidth name="phone" required={required.phone} />
                                    </Box>
                                    <Box mt={3}>
                                        <TextField label="Company Name" fullWidth name="companyName" required={required.companyName} />
                                    </Box>
                                    <Box mt={3}>
                                        <TextField label="Start typing your message..." fullWidth multiline rows={10} name="message" required={required.message} />
                                    </Box>

                                    <BoxButton
                                        style={{ position: 'absolute', bottom: 0, left: 0 }}
                                        type="submit"
                                        text={'SEND A MESSAGE'}
                                        iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
                                    />
                                </form>
                            )
                        }}
                    />
                </SideDrawer>
            </div >
        )
    }
}

export default withWidth()(ContactUs);